module.exports = __webpack_public_path__ + "img/menu-change-pwd.0df9d28f.svg";